var OCS = OCS || {};
/**
 * Overriding the default behavior from ocsgeometrymanager for request properties
 * @param ops
 * @returns {{dataType: string, responseType: string, storeCompletedReq: number}}
 */
OCS.Geometry.Functions.getDefaultRequestProp = function(ops) {
    var req_settings = {'dataType': 'json', 'responseType': 'json', "storeCompletedReq": 1};
    if(!ops) {
        req_settings.method = "GET";
        return req_settings;
    }
    if(!ops.request_method) {
        req_settings.method = "GET"; // Default to GET
    }
    if(ops.url) {
        req_settings.url = ops.url;
    }
    if(ops.request_success_method) {
        req_settings.onSuccess = ops.request_success_method;
    }
    if(ops.request_failure_method) {
        req_settings.onFailure = ops.request_failure_method;
    }
    var cache = OCS.Geometry.Functions.getGeometryCached();
    if(cache) {
        req_settings.cache = true;
    } else {
        req_settings.cache = false;
        req_settings.noCache = true;
    }
    return req_settings;
};
/**
 * Returns the level of simplification given a resolution based on the OCS.Viewer.Config.resolution_to_simplification relationship
 * @param Float resolution
 * @returns Float simplification
 */
OCS.Geometry.Functions.get_simplification = function(resolution) {
    var res_keys = Object.keys(OCS.Viewer.Config.resolution_to_simplification);
    var key;
    var prev_key = 0;
    for(var i=0; i<res_keys.length; i++) {
        key = parseFloat(res_keys[i]);
        // Test if the key meets the conditions, special condition of resolution being >= added to account for when prev_key is 0 on the first iteration
        if(resolution <= key && resolution >= prev_key) {
            return OCS.Viewer.Config.resolution_to_simplification[res_keys[i]];
        }
        prev_key = key;
    }
    return OCS.Viewer.Config.resolution_to_simplification[res_keys[res_keys.length-1]];
};



